"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginNetwork = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var const_1 = require("../utils/const");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var defaultOption = {
    sampleRate: 10,
    disable: false,
    ignoreList: [
        'https?://report.meituan.com/',
        'https?://wreport1.meituan.net',
        'https?://wreport2.meituan.net',
        'https?://[a-z_0-9\\-]*.dreport.meituan.net',
        'https?://dreport.meituan.net',
        'https?://catfront.dianping.com',
        'https?://catfront.51ping.com',
        'https?://postreport.meituan.com',
    ],
};
var PluginNetwork = /** @class */ (function (_super) {
    tslib_1.__extends(PluginNetwork, _super);
    function PluginNetwork(queue, config) {
        if (config === void 0) { config = defaultOption; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginNetwork.id;
        _this.config = util_1.extend(defaultOption, _this.config);
        // 将 queue中 transport 上报的 endpoint 则需要将 endpoint 加入 ignoreList
        var customEndpoint = _this.queue.transport.options.endpoint;
        if (customEndpoint) {
            _this.config.ignoreList.push(customEndpoint);
        }
        return _this;
    }
    PluginNetwork.prototype.init = function () {
        this.interceptAjax();
        this.interceptFetch();
    };
    PluginNetwork.prototype.interceptAjax = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var pluginIns = this;
        var xhr = window.XMLHttpRequest;
        if (!xhr || xhr._perf)
            return;
        xhr._perf = true;
        if (util_1.getProtocol() === 'file:')
            return;
        var _open = xhr.prototype.open;
        var _send = xhr.prototype.send;
        xhr.prototype.open = function (method, url) {
            this._perf_url = url;
            this._perf_method = method;
            this._perf_startTime = Date.now();
            return _open && _open.apply(this, arguments);
        };
        xhr.prototype.send = function () {
            var _this = this;
            var EVENT_LISTENER = 'addEventListener';
            var STATE_CHANGE = 'onreadystatechange';
            var _dispatchEvent = function (event) {
                var _a;
                if (!event)
                    return;
                try {
                    var duration = Date.now() - _this._perf_startTime;
                    var url = _this.responseURL || _this._perf_url;
                    var size = ((_a = event) === null || _a === void 0 ? void 0 : _a.total) || 0;
                    var status_1 = _this.status || 500;
                    if (isNaN(duration))
                        return;
                    // 补齐 url
                    url = pluginIns.formatUrl(url);
                    var protocol = util_1.getProtocolByUrl(url);
                    if (!pluginIns.filterRequest(url))
                        return;
                    pluginIns.addHttpData({
                        url: url,
                        duration: duration,
                        method: _this._perf_method,
                        status: status_1,
                        size: size,
                        protocol: protocol,
                        reqType: typings_1.REQ_TYPE.XHR,
                    });
                }
                catch (error) {
                    logger_1.default.log('处理 ajax 信息异常', error);
                }
            };
            if (EVENT_LISTENER in this) {
                this[EVENT_LISTENER]('load', _dispatchEvent);
                this[EVENT_LISTENER]('error', _dispatchEvent);
                this[EVENT_LISTENER]('abort', _dispatchEvent);
            }
            else {
                var _originStateChange_1 = this[STATE_CHANGE];
                this[STATE_CHANGE] = function (event) {
                    if (this.readyState === 4) {
                        _dispatchEvent(event);
                    }
                    _originStateChange_1 && _originStateChange_1.apply(this, arguments);
                };
            }
            return _send && _send.apply(this, arguments);
        };
    };
    PluginNetwork.prototype.interceptFetch = function () {
        var _this = this;
        var fetch = window.fetch;
        if (!util_1.isFunction(fetch) || fetch._perf)
            return;
        if (util_1.getProtocol() === 'file:')
            return;
        var oldFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = _this.getFetchUrl(input);
            var method = _this.getFetchMethod(input, init);
            url = _this.formatUrl(url);
            var protocol = util_1.getProtocolByUrl(url);
            if ((init && init.mode === 'no-cors') || !_this.filterRequest(url)) {
                return oldFetch.call(window, input, init);
            }
            var startTime = Date.now();
            return (oldFetch &&
                oldFetch
                    .call(window, input, init)
                    .then(function (res) {
                    try {
                        if (!util_1.isFunction(res === null || res === void 0 ? void 0 : res.clone))
                            return res;
                        var copy_1 = res.clone();
                        var resHeaders = copy_1.headers;
                        if (resHeaders && util_1.isFunction(resHeaders.get)) {
                            var contentType = resHeaders.get('content-type');
                            if (contentType && !/(text)|(json)/.test(contentType))
                                return res;
                        }
                        copy_1
                            .arrayBuffer()
                            .then(function (af) {
                            _this.addHttpData({
                                url: url,
                                method: method,
                                status: copy_1.status,
                                size: af.byteLength,
                                duration: Date.now() - startTime,
                                protocol: protocol,
                                reqType: typings_1.REQ_TYPE.FETCH,
                            });
                        })
                            .catch(function () {
                            logger_1.default.log('上报异常');
                        });
                        return res;
                    }
                    catch (e) {
                        return res;
                    }
                })
                    .catch(function (err) {
                    _this.addHttpData({
                        url: url,
                        method: method,
                        status: 500,
                        size: 0,
                        protocol: protocol,
                        duration: Date.now() - startTime,
                        reqType: typings_1.REQ_TYPE.FETCH,
                    });
                    throw err;
                }));
        };
        window.fetch._perf = true;
    };
    PluginNetwork.prototype.getFetchMethod = function (input, init) {
        var method = 'get';
        if (init && init.method) {
            method = init.method;
        }
        else if (typeof input !== 'string') {
            method = (input === null || input === void 0 ? void 0 : input.method) || 'get';
        }
        return method.toLowerCase();
    };
    PluginNetwork.prototype.getFetchUrl = function (input) {
        if (typeof input === 'string')
            return input;
        if (input.url)
            return input.url;
        if (input instanceof URL)
            return input === null || input === void 0 ? void 0 : input.href;
        return '';
    };
    PluginNetwork.prototype.filterRequest = function (url) {
        if (!url)
            return false;
        try {
            for (var _i = 0, _a = this.config.ignoreList; _i < _a.length; _i++) {
                var regStr = _a[_i];
                var reg = new RegExp(regStr);
                if (reg.test(url))
                    return false;
            }
            return true;
        }
        catch (error) {
            logger_1.default.log('过滤请求url失败', error);
            return false;
        }
    };
    PluginNetwork.prototype.addHttpData = function (_a) {
        var url = _a.url, duration = _a.duration, method = _a.method, status = _a.status, size = _a.size, reqType = _a.reqType, protocol = _a.protocol;
        this.addData({
            type: const_1.METRICS_NETWORK,
            ts: Date.now(),
            value: duration,
            tags: {
                url: url,
                status: status,
                method: method.toLowerCase && method.toLowerCase(),
                size: size,
                reqType: reqType,
                protocol: protocol,
            },
        });
    };
    PluginNetwork.prototype.addRequest = function (req) {
        var _a = req || {}, url = _a.url, duration = _a.duration, resSize = _a.resSize, method = _a.method, status = _a.status, protocol = _a.protocol;
        this.addHttpData({
            url: url,
            duration: duration,
            size: resSize || 0,
            reqType: typings_1.REQ_TYPE.CUSTOM,
            status: status,
            method: method || '',
            protocol: protocol,
        });
    };
    /**
     * 格式化请求 url 省略protocol 或域名时 进行补齐
     * @param url 原始url
     * @return {string} 最终上报用url
     */
    PluginNetwork.prototype.formatUrl = function (url) {
        if (url.indexOf('//') === 0) {
            url = util_1.getProtocol() + url;
        }
        else if (url.indexOf('/') === 0) {
            url = util_1.getOrigin() + url;
        }
        return url;
    };
    PluginNetwork.id = typings_1.PLUGIN_NAME.NETWORK;
    return PluginNetwork;
}(basePlugin_1.default));
exports.PluginNetwork = PluginNetwork;
//# sourceMappingURL=network.js.map